import * as Yup from "yup";

const addAchCardValidationSchema = Yup.object({
    achDetails: Yup.object({
        accountType: Yup.string().required("Required"),
        accountNumber: Yup.string().required("Required"),
        routingNumber: Yup.string().required("Required"),
        nameOnAccount: Yup.string().required("Required"),
    }),
})


export default addAchCardValidationSchema